import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.3.1_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.3.1_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["BackButton"] */ "/vercel/path0/src/components/back-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/filter-event-bar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Pages/Eventos/ButtonConfirmed.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ui/scroll-area.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ui/separator.tsx");
